import { useEffect, useState } from "react";

import { fetchLogEntryByID } from "../../../utils/IntegrationsManagementAPIClient";
import { APIRequestLogEntry } from "../../../IntegrationsManagementEntities";

export const LOG_ID_PARAM = "log_id";

const useLogEntryFromQuery = (searchString: string): APIRequestLogEntry | undefined => {
  const [logEntry, setLogEntry] = useState<APIRequestLogEntry>();

  // Fetch the log entry from the server when the URL contains ?log_id=...
  // This is how the API tester auto-populates from a log without persisting any payload client-side.
  useEffect(() => {
    const params = new URLSearchParams(searchString);
    const logID = params.get(LOG_ID_PARAM);
    if (!logID) return;
    let cancelled = false;
    fetchLogEntryByID({
      logID,
      onSuccess: (data) => {
        if (!cancelled) setLogEntry(data);
      },
      onError: () => {
        // Fall through to an empty form on 404 / permission errors.
      },
    });
    return () => {
      cancelled = true;
    };
  }, [searchString]);

  return logEntry;
};

export default useLogEntryFromQuery;
